import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { useState } from "react";
import { Toast } from "primereact/toast";
import { useRef } from "react";
import { Tag } from "primereact/tag";

interface AccountsCashRow {
  date: string;
  userID: number;
  acceptedCashAmount: number;
  invoiceAmount: number;
  totalCash: number;
}

interface AccountsCashDatatableProps {
  data: AccountsCashRow[];
  loading: boolean;
  refreshData: () => void;
}

const AccountsCashDatatable: React.FC<AccountsCashDatatableProps> = ({
  data,
  loading,
  refreshData,
}) => {
  const toast = useRef<Toast>(null);
  const [showHandoverDialog, setShowHandoverDialog] = useState(false);
  const [handoverData, setHandoverData] = useState<AccountsCashRow | null>(null);
  const sortedData = [...data].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  const formatDate = (rowData: AccountsCashRow) => {
    const dt = new Date(rowData.date);
    return dt.toLocaleDateString("en-GB");
  };


  return (
    <div className="card border-noround p-2">
      <Toast ref={toast} position="top-right" />

      <DataTable
        value={sortedData}
        loading={loading}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 20, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column header="Date" body={formatDate} style={{ width: "15%" }} sortable/>
        {/* <Column field="acceptedCashAmount" header="Total Cash Collected" style={{ width: "15%" }} sortable/> */}
        {/* <Column field="invoiceAmount" header="Invoiced Amount" style={{ width: "15%" }} sortable/> */}
        <Column field="totalCash" header="Total Amount" style={{ width: "15%" }} sortable/>

      </DataTable>
    </div>
  );
};

export default AccountsCashDatatable;
